import { render, staticRenderFns } from "./CardAvatar.vue?vue&type=template&id=3223c09a&scoped=true&"
import script from "./CardAvatar.vue?vue&type=script&lang=js&"
export * from "./CardAvatar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3223c09a",
  null
  
)

export default component.exports